export default (formtatedString) => {
  if (!formtatedString || typeof formtatedString !== 'string') {
    return formtatedString;
  }

  let unFormatedString = formtatedString;
  unFormatedString = unFormatedString.replace(/[^a-z0-9]/gi, '');
  return unFormatedString;
};
